import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close, Body } from "MODULES/shared/components/Modal";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import { DropDownItem, Icon } from "MODULES/shared/components";
import { ToggleSwitch } from "MODULES/shared/containers";
import Form from "./Form";

function Download({ salesOrder }) {
  const [includedItems, setIncludedItems] = useState([]);

  return (
    <ToggleSwitch>
      {(visible, open, close) => (
        <DropDownItem onClick={open}>
          <Icon name="download" fixed />
          &nbsp;Print All CoCs
          <Modal open={visible} close={close} dialogClass="modal-md">
            <Header>
              <Close close={close} />
              <h4 className="modal-title">CoC Obtained From</h4>
            </Header>
            <Body>
              <Form
                salesOrder={salesOrder}
                close={close}
                includedItems={includedItems}
                setIncludedItems={setIncludedItems}
              />
            </Body>
          </Modal>
        </DropDownItem>
      )}
    </ToggleSwitch>
  );
}

Download.propTypes = {
  salesOrder: PropTypes.shape({})
};

export default withSalesOrder(Download);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/DownloadCoC/Download.jsx